/* Native scrolling drives the three moments; buttons remain a keyboard alternative. */
if (!customElements.get('yawana-studio')) {
  customElements.define('yawana-studio', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const { signal } = this.abort;
      const frame = this.querySelector('.yw-studio__frame');
      const controls = this.querySelector('.yw-studio__controls');
      const buttons = [...this.querySelectorAll('[data-moment]')];
      const caption = this.querySelector('.yw-studio__caption');
      let scrollRoot = this.parentElement;
      while (scrollRoot && !/(auto|scroll)/.test(getComputedStyle(scrollRoot).overflowY)) scrollRoot = scrollRoot.parentElement;
      if (scrollRoot === document.body || scrollRoot === document.documentElement) scrollRoot = null;
      const scroller = scrollRoot || window;
      const viewportHeight = () => scrollRoot ? scrollRoot.clientHeight : innerHeight;
      const viewportTop = () => scrollRoot ? scrollRoot.getBoundingClientRect().top : 0;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (!frame || !buttons.length) return;
      controls.hidden = false;
      const select = index => {
        if (this.dataset.scene === String(index)) return;
        this.dataset.scene = String(index);
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        caption.textContent = buttons[index].querySelector('[data-caption]').textContent;
      };
      const update = () => {
        this.tick = null;
        if (!this.classList.contains('yw-studio--scroll')) return;
        const position = scrollRoot ? scrollRoot.scrollTop : scrollY;
        if (this.manualPosition === position) return;
        this.manualPosition = null;
        const distance = Math.min(360, viewportHeight() * .42);
        const progress = Math.max(0, Math.min(1, (viewportTop() - this.getBoundingClientRect().top) / distance));
        select(Math.min(buttons.length - 1, Math.floor(progress * buttons.length)));
      };
      const schedule = event => {
        if (event?.type === 'scroll') this.manualPosition = null;
        if (scrollRoot && !/(auto|scroll)/.test(getComputedStyle(scrollRoot).overflowY)) scrollRoot = null;
        if (event?.type === 'scroll') { update(); return; }
        if (!this.tick) this.tick = requestAnimationFrame(update);
      };
      const layout = () => {
        const enabled = !reduced.matches && buttons.length > 1;
        this.classList.toggle('yw-studio--scroll', enabled);
        controls.querySelector('.yw-studio__control-label').textContent = enabled ? 'SCROLL THROUGH YOUR DAY ↓' : 'A MOMENT FOR YOU';
        schedule();
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        this.manualPosition = scrollRoot ? scrollRoot.scrollTop : scrollY;
        select(index);
      }, { signal }));
      scroller.addEventListener('scroll', schedule, { passive: true, signal });
      if (scroller !== window) window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', layout, { signal });
      reduced.addEventListener('change', layout, { signal });
      this.addEventListener('shopify:block:select', event => event.target.closest('[data-moment]')?.click(), { signal });
      layout();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.tick);
      this.tick = null;
    }
  });
}
